const Style = {
    article: `mx-auto max-w-3xl px-6 py-12 md:py-16
    [&_h1]:mb-3 [&_h1]:text-2xl [&_h1]:font-semibold [&_h1]:text-primary-700 dark:[&_h1]:text-primary-300
    [&_h2]:mb-2 [&_h2]:mt-10 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-primary-700 dark:[&_h2]:text-primary-300
    [&_h3]:mb-3 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-text-primary
    [&_p]:mb-4 [&_p]:text-sm [&_p]:leading-relaxed [&_p]:text-text-secondary
    [&_ul]:mb-4 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:text-sm [&_ul]:text-text-secondary
    [&_li]:mb-1.5`,
};

export default Style;
